import type { GameDef } from '../registry';
import { formatTime } from './engine';

/** the picker's view of the game; the view imports this and the registry imports index.ts */
export const dropCodeDef: Omit<GameDef, 'mount'> = {
  id: 'dropcode',
  title: 'Drop Code',
  icon: '📡',
  blurb: 'Support is one code away. Punch the arrows in before the window shuts — ten call-ins, against the clock.',
  howTo: [
    'A call-in comes up with a code: a short run of arrows. Punch it in on the pad.',
    'The pad reads on the way down, not the way up. Hit it, do not hover.',
    'A wrong arrow costs 2 seconds and knocks the code back to the start — but the call-in stays yours.',
    'Run out of window and the call-in is lost for good, plus the 2 seconds.',
    'Every call-in keeps the same code every time you play, so sooner or later you stop reading and start knowing.',
    'Ten landed and you are out. The clock is your score — fastest time wins the leaderboard.',
  ],
  scoreLabel: 'time',
  lowerIsBetter: true,
  formatScore: formatTime,
};
